<template>
  <provider-show-section :title="$t('MESSAGES.centerDetails')">
    <div class="provider_show_grid provider_show_grid--2">
      <div class="provider_show_field">
        <span class="provider_show_label">{{ $t("PLACEHOLDERS.descriptionAr") }}</span>
        <p class="provider_show_value">{{ displayValue(descriptionAr) }}</p>
      </div>
      <div class="provider_show_field">
        <span class="provider_show_label">{{ $t("PLACEHOLDERS.descriptionEn") }}</span>
        <p class="provider_show_value provider_show_value--ltr">
          {{ displayValue(descriptionEn) }}
        </p>
      </div>
    </div>

    <div class="provider_show_grid provider_show_grid--3 provider_show_grid--spaced">
      <div class="provider_show_field">
        <span class="provider_show_label">{{ $t("PLACEHOLDERS.email") }}</span>
        <p class="provider_show_value provider_show_value--ltr">
          {{ displayValue(email) }}
        </p>
      </div>
      <div class="provider_show_field">
        <span class="provider_show_label">{{ $t("PLACEHOLDERS.mobileNumber") }}</span>
        <p class="provider_show_value provider_show_value--ltr">
          {{ displayValue(mobile) }}
        </p>
      </div>
      <div class="provider_show_field">
        <span class="provider_show_label">
          {{ $t("MESSAGES.Commission percentage from the center") }}
        </span>
        <p class="provider_show_value provider_show_value--ltr">
          {{ commissionLabel }}
        </p>
      </div>
    </div>
  </provider-show-section>
</template>

<script>
import ProviderShowSection from "./ProviderShowSection.vue";
import { displayValue } from "@/utils/festivalProviderShow";

export default {
  name: "ProviderShowDetails",
  components: { ProviderShowSection },
  props: {
    descriptionAr: { type: String, default: null },
    descriptionEn: { type: String, default: null },
    email: { type: String, default: null },
    mobile: { type: String, default: null },
    commission: { type: [String, Number], default: null },
  },
  computed: {
    commissionLabel() {
      if (this.commission !== null && this.commission !== "") {
        return `${this.commission}%`;
      }
      return "-";
    },
  },
  methods: {
    displayValue,
  },
};
</script>
